"use client";

import { Button } from "@mui/material";
import { Dropdown, Navbar } from "flowbite-react";
import { useEffect, useState } from "react";
import { LogoutUser } from "../redux/slices/auth";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Avatar from "./Avatar";
import EditUserDetails from "./EditUserDetails";
export const Nav = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {user} = useSelector((state)=>state.auth)
  const [editUserOpen , setEditUserOpen]=useState(false);
  
  const handleClick = () => {
    dispatch(LogoutUser());
    navigate("/auth/login");
    localStorage.clear();
  };
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.shiftKey && e.key === 'D') {
        e.preventDefault(); // Prevent the default print dialog
        setEditUserOpen(true);
      }else if(e.ctrlKey && e.key === 'f'){
        e.preventDefault(); // Prevent the default print dialog
       handleClick();
      }else if(e.ctrlKey && e.shiftKey && e.key === "K"){
        e.preventDefault();
        navigate('/setting')
      }
      else if(e.ctrlKey && e.key === "m"){
        e.preventDefault();
        navigate('/call')
      }
      
    };
  
    window.addEventListener('keydown', handleKeyDown);
  
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);
  return (
    <Navbar
      fluid
      rounded
      className={` mx-auto left-auto top-0 h-15 sticky z-20 w-full max-w-8xl dark:bg-transparent bg-transparent`}
    >
      <span className="self-center  whitespace-nowrap text-3xl font-bold text-white cursor-pointer" onClick={()=>navigate("/app")}>
        GemX
      </span>

      <div className="flex justify-center items-center md:order-2 gap-10">
        {/* <button
          onClick={toggleTheme}
          type="button"
          className="relative rounded-full p-1 text-gray-400 hover:dark:text-white hover:text-slate-300 focus:outline-none  focus:ring-offset-gray-800"
        >
          <span className="absolute -inset-1.5" />
          <span className="sr-only">Brightness</span>
          <TiAdjustBrightness
            onClick={() => {
              console.log("Hello");
            }}
            className="h-8 w-8"
            aria-hidden="true"
          />
        </button> */}

        <Dropdown
          arrowIcon={false}
          
          inline
          label={
            <div className="border-2 rounded-full ">
            <Avatar
              width={45}
              height={45}
              name={user?.firstName}
              imageUrl={user?.profile_pic}
              userId=""
              rounded
            />
            </div>
          }
        >
          <Dropdown.Item>
            <Button className="mx-auto"
            title={user?.firstName}
            onClick={() => setEditUserOpen(true)}>Profile</Button>
          </Dropdown.Item>
          <Dropdown.Item>
            <Button onClick={()=>navigate('/setting')}>Setting</Button>
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item>
            <Button onClick={handleClick}>SignOut</Button>
          </Dropdown.Item>
        </Dropdown>
        <Navbar.Toggle />
      </div>
      <Navbar.Collapse>
         <Navbar.Link
          onClick={() => navigate("/premium")}
          className="text-base cursor-pointer nav text-yellow-400 md:bg-transparent backdrop-blur-md md:backdrop-blur-0"
        >
          Go Premium
          <svg
            className="w-4 h-4 inline-block mb-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M12 3L13.4302 8.31181C13.6047 8.96 13.692 9.28409 13.8642 9.54905C14.0166 9.78349 14.2165 9.98336 14.451 10.1358C14.7159 10.308 15.04 10.3953 15.6882 10.5698L21 12L15.6882 13.4302C15.04 13.6047 14.7159 13.692 14.451 13.8642C14.2165 14.0166 14.0166 14.2165 13.8642 14.451C13.692 14.7159 13.6047 15.04 13.4302 15.6882L12 21L10.5698 15.6882C10.3953 15.04 10.308 14.7159 10.1358 14.451C9.98336 14.2165 9.78349 14.0166 9.54905 13.8642C9.28409 13.692 8.96 13.6047 8.31181 13.4302L3 12L8.31181 10.5698C8.96 10.3953 9.28409 10.308 9.54905 10.1358C9.78349 9.98336 9.98336 9.78349 10.1358 9.54905C10.308 9.28409 10.3953 8.96 10.5698 8.31181L12 3Z"
              clipRule="evenodd"
            />
          </svg>
        </Navbar.Link>
        <Navbar.Link
          onClick={() => navigate("/aboutus")}
          className="navbutton dark:text-slate-200 text-black cursor-pointer hover:text-slate-400 hover:dark:text-slate-400 backdrop-blur-md md:backdrop-blur-0"
        >
          About us
        </Navbar.Link>
        <Navbar.Link
          onClick={() => navigate("/help")}
          className="navbutton dark:text-slate-200 text-black cursor-pointer hover:text-slate-400 hover:dark:text-slate-400 backdrop-blur-md md:backdrop-blur-0"
        >
          Help
        </Navbar.Link>
        <Navbar.Link
          onClick={() => navigate("/privacypolicy")}
          className="navbutton dark:text-slate-200 text-black cursor-pointer hover:text-slate-400 hover:dark:text-slate-400 backdrop-blur-md md:backdrop-blur-0"
        >
          Privacy Policy
        </Navbar.Link>
        
      </Navbar.Collapse>

      {/* Edit user details */}
      {editUserOpen && (
        <EditUserDetails onClose={() => setEditUserOpen(false)} />
      )}
    </Navbar>
  );
};
